<div tabindex="-1"
     role="dialog"
     class="modal">
  <button aria-label="Close" @click="$emit('modal-close')"> <svg
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 640 640"><!--!Font Awesome Free v7.3.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
      <path
            d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" />
    </svg> </button>
  <form>
    <div class="icons"
         :class="{'enter-text': feedback.emoji, 'pick-icon': !feedback.emoji}">
      <template v-for="name in icons.names">
        <input type="radio"
               v-bind:id="name + '-' + page_id"
               v-bind:value="name"
               v-model="feedback.emoji">
        <label class="emoji"
               tabindex="0"
               v-bind:for="name + '-' + page_id">
          <span role="img" v-html="icons[name].emoji"></span>
          <span class="icon-desc">
            {{icons[name].text}}
          </span>
        </label>
      </template>
    </div>
    <template v-if="feedback.emoji">
      <div v-if="admin">
        <!-- to manually enter notes from social media -->
        <label for="name">Name</label> <br>
        <input type="text"
               v-model="feedback.name"
               class="p-2"
               id="name">
      </div>
      <textarea ref="content"
                required
                v-model="feedback.content"
                v-bind:placeholder="icons[feedback.emoji].prompt"></textarea>
      <div v-if="modal_error"
           style="text-align: left; color: var(--red-8); margin: 1rem 0">
        {{modal_error}}
      </div>
      <button class="btn"
              :class="{
                 'saving': button_text == 'Saving...',
              }"
              @click.prevent="save">
        {{ button_text }}
      </button>
    </template>
  </form>
</div>
